import bonusBuyComponent from 'components/bonus-buy/bonus-buy-component';
import { StaticSymbolsCommand } from 'slotworks/commands/symbols/static-symbols-command';
import Components from 'slotworks/components/components';
import soundManager from 'slotworks/sound/sound-manager';
import RequestSpin from 'slotworks/state-machine/standard/states/request-spin';
import doSettingsModel from 'model/do-settings-model';

export default class RequestSpins extends RequestSpin {
    public onEnter() {
        doSettingsModel.isCurrentBonusBuyOut = false;
        bonusBuyComponent.setEnabled(false);
        Components.celebrateWin.hide();
        StaticSymbolsCommand().execute();
        soundManager.customEvent('stop_start_spin_sounds');
        super.onEnter();
    }
}



// WEBPACK FOOTER //
// ./src/states/request-spin.ts